import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=405baa63&scoped=true"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=405baa63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405baa63",
  null
  
)

export default component.exports